import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20soft%20ambient%20lighting%2C%20traditional%20Chinese%20tea%20room%20atmosphere%2C%20bamboo%20shadows%20on%20rice%20paper%20walls%2C%20warm%20golden%20hour%20light%2C%20peaceful%20and%20inviting%20mood%2C%20artistic%20photography%2C%20soft%20focus%20background&width=1920&height=800&seq=cta-bg-02&orientation=landscape"
          alt="立即开启阅读之旅"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/60 backdrop-blur-[2px]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-6 tracking-wide">
          立即开启阅读之旅
        </h2>
        <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto mb-4 leading-relaxed">
          海量高清韩漫等你来发现
        </p>
        <p className="text-sm md:text-base text-background-50/60 max-w-xl mx-auto mb-10 leading-relaxed">
          每日更新，免费畅读，下拉式流畅体验
        </p>

        <Link
          to="/category/all"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-base font-semibold hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-book-open-line text-background-50"></i>
          </div>
          免费开始阅读
          <i className="ri-arrow-right-up-line text-xl"></i>
        </Link>
      </div>
    </section>
  );
}